import { render } from "./confirm.vue?vue&type=template&id=ef319174&scoped=true"
import script from "./confirm.vue?vue&type=script&lang=ts"
export * from "./confirm.vue?vue&type=script&lang=ts"

import "./confirm.vue?vue&type=style&index=0&id=ef319174&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ef319174"

export default script